import { useLang } from "@/i18n/LanguageContext";
import { Check, Store, Users, Wallet } from "lucide-react";

const SupplierSection = () => {
  const { t } = useLang();
  const p = t.supplier.productExample;
  return (
    <section id="suppliers" className="py-24 md:py-32 bg-cream">
      <div className="container grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-primary-glow">{t.supplier.eyebrow}</span>
          <h2 className="mt-3 text-3xl sm:text-4xl md:text-6xl font-extrabold leading-[1.05]">{t.supplier.title}</h2>
          <p className="mt-5 text-lg md:text-xl text-muted-foreground">{t.supplier.desc}</p>
          <ul className="mt-8 space-y-3">
            {t.supplier.bullets.map((b) => (
              <li key={b} className="flex items-start gap-3">
                <span className="mt-0.5 inline-flex h-6 w-6 items-center justify-center rounded-full bg-primary text-primary-foreground shrink-0">
                  <Check className="h-3.5 w-3.5" />
                </span>
                <span>{b}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="space-y-4">
          <div className="rounded-3xl bg-background shadow-card border border-border p-6">
            <div className="grid grid-cols-3 gap-3">
              <div className="rounded-2xl bg-mint p-4">
                <Store className="h-5 w-5" />
                <div className="mt-3 text-sm font-extrabold leading-tight">{t.supplier.tile1Title}</div>
                <div className="mt-1 text-xs opacity-80">{t.supplier.tile1Desc}</div>
              </div>
              <div className="rounded-2xl bg-coral p-4">
                <Users className="h-5 w-5" />
                <div className="mt-3 text-sm font-extrabold leading-tight">{t.supplier.tile2Title}</div>
                <div className="mt-1 text-xs opacity-80">{t.supplier.tile2Desc}</div>
              </div>
              <div className="rounded-2xl bg-lavender p-4">
                <Wallet className="h-5 w-5" />
                <div className="mt-3 text-sm font-extrabold leading-tight">{t.supplier.tile3Title}</div>
                <div className="mt-1 text-xs opacity-80">{t.supplier.tile3Desc}</div>
              </div>
            </div>
          </div>

          <div className="rounded-3xl bg-background shadow-card border border-border p-6">
            <div className="text-xs font-bold uppercase tracking-widest text-muted-foreground">Voorbeeld</div>
            <div className="mt-2 text-xl font-extrabold">{p.name}</div>
            <div className="mt-1 text-sm text-muted-foreground">{p.lead}</div>
            <div className="mt-4 flex items-end justify-between">
              <div className="text-3xl font-extrabold">{p.price}</div>
              <div className="text-xs font-bold rounded-full bg-mint text-mint-foreground px-3 py-1">{t.supplier.youDecide}</div>
            </div>
          </div>
        </div>
      </div>

      <div className="container mt-12 grid lg:grid-cols-5 gap-6">
        <div className="lg:col-span-2 rounded-3xl bg-background border border-border p-6 md:p-8 shadow-card">
          <h3 className="text-xl md:text-2xl font-extrabold leading-tight">{t.supplier.dashboardTitle}</h3>
          <p className="mt-3 text-sm md:text-base text-muted-foreground">{t.supplier.dashboardDesc}</p>
        </div>
        <div className="lg:col-span-3 rounded-3xl bg-lavender p-6 md:p-8 text-lavender-foreground">
          <h3 className="text-xl md:text-2xl font-extrabold leading-tight">{t.supplier.premiumTitle}</h3>
          <p className="mt-3 text-sm md:text-base opacity-90">{t.supplier.premiumDesc}</p>
          <ul className="mt-4 space-y-2">
            {t.supplier.premiumBullets.map((b) => (
              <li key={b} className="flex items-start gap-2 text-sm">
                <Check className="h-4 w-4 mt-0.5 shrink-0" />
                <span>{b}</span>
              </li>
            ))}
          </ul>
          <div className="mt-4 text-xs font-semibold opacity-75">{t.supplier.premiumNote}</div>
        </div>
      </div>
    </section>
  );
};

export default SupplierSection;
